module.exports = __webpack_public_path__ + "static/media/short_classic_collar.0db5d75d.svg";